type DebugBannerProps = {
    isDebug: boolean;
    debugStatus: string[] | null;
};

export const DebugBanner = ({isDebug, debugStatus}: DebugBannerProps) => {
    if (!isDebug || !debugStatus) return null;

    return (
        <div
            style={{
                position: 'absolute',
                bottom: 100,
                left: 0,
                right: 0,
                zIndex: 9999,
                background: 'rgba(180,0,0,0.85)',
                color: '#fff',
                fontFamily: 'monospace',
                fontSize: '13px',
                padding: '8px 12px',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all',
            }}
        >
            <strong>[DEBUG]</strong> Widget kept open — call closed without unmounting.
            <br />
            {/* reasons each in new line */}
            {debugStatus.map((status, index) => (
                <span key={index}>
                    {status}
                    <br />
                </span>
            ))}
        </div>
    );
};
